import { type Tag } from '@hungryroot/rest';
import { productContainsNeverTag, useNeveredTagIds } from '@hungryroot/tags';
import { getProductNeverTagName } from '../utils/getProductNeverTagName';

export function useFoodProfileNeverOverride({
  productTags,
  enabled = false,
}: {
  productTags?: Tag[] | number[];
  enabled?: boolean;
}): { showFoodProfileNeverOverride: boolean; neverTagName: string | null } {
  const neveredTagIds = useNeveredTagIds({ enabled });

  const isTagNever =
    enabled && productContainsNeverTag(productTags, neveredTagIds);

  const neverTagName =
    isTagNever && productTags
      ? getProductNeverTagName(productTags, neveredTagIds)
      : null;

  return {
    showFoodProfileNeverOverride: isTagNever,
    neverTagName,
  };
}
